import React, { CSSProperties, FC } from 'react'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import { colors } from '@lmc/common/constants'
import './MultiTextArea.less'
import { IconType } from '../../atoms/Icon/iconTypes'
import Icon from '../../atoms/Icon'
import Text from '../../atoms/Text'
import Popover from '../../atoms/Popover'
import InputText from '../InputText'
import './MultiTextArea.less'
import { AboutMe } from '@lmc/ts-common'

type MultiTextAreaField = {
  source: string
  value: string
  element: 'input' | 'textarea'
  editMode: boolean
  label: string
  localisation: { description: string; writtenBy: string }
}

export type MultiTextAreaProps = {
  heading: string
  headingInfo: string
  tooltip: string
  fields?: MultiTextAreaField[]
  printPDF?: boolean
  formChange?: AboutMe
  printPDFPageBreak?: boolean
}

const MultiTextArea: FC<MultiTextAreaProps> = ({
  heading,
  headingInfo,
  fields,
  tooltip,
  printPDF,
  formChange,
  printPDFPageBreak = true,
}) => {
  const styles = {
    container: {
      display: 'flex',
      backgroundColor: colors.white,
      borderRadius: 25,
      padding: '20px 24px',
      width: '100%',
      flexDirection: 'column',
    },
    heading: {
      fontWeight: 400,
      marginLeft: printPDF ? 30 : 0,
      maxWidth: !printPDF ? 540 : 'inherit',
      wordBreak: 'break-all',
      display: 'flex',
    },
    headingInfo: { marginBottom: 5, color: colors.darkgrey, marginRight: 20 },
    headingContainer: {
      display: 'flex',
      alignItems: 'center',
      marginRight: 5,
      borderRadius: 4,
    },
    headingRow: {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap' as any,
      justifyContent: 'space-between',
      marginBottom: 5,
    },
    questionIcon: { marginBottom: '-3px', marginLeft: 5, marginTop: 4 },
    toolTip: {
      width: '50vw',
      maxWidth: 606,
    },
    mainContainer: { marginTop: 50 },
    viewcontainer: {
      display: 'flex',
      flexDirection: 'column',
      borderRadius: 4,
    },
    borderContainer: {
      border: '1px solid',
      borderColor: colors.grey,
    },
    formItemRow: {
      marginBottom: 0,
    },
  }

  return (
    <div
      style={styles.mainContainer}
      className={printPDFPageBreak ? 'page-break-after' : ''}
    >
      <div style={styles.headingRow}>
        <div style={styles.headingContainer}>
          <Text
            as={!printPDF ? 'h4' : 'h3'}
            style={styles.heading as CSSProperties}
          >
            {heading}
            {!printPDF && (
              <Popover
                placement="bottom"
                content={<div style={styles.toolTip}>{tooltip}</div>}
              >
                <div>
                  <Icon
                    customIcon={IconType.Question}
                    style={styles.questionIcon}
                  />
                </div>
              </Popover>
            )}
          </Text>
        </div>
        <div style={styles.headingInfo}>{headingInfo}</div>
      </div>
      <div style={styles.container as CSSProperties}>
        {fields?.map((field, index) => {
          const label =
            index === 0
              ? field.localisation.description
              : field.localisation.writtenBy

          const isEditMode = field.editMode

          const parentField = field.source.replace('WrittenBy', '')

          // @ts-ignore
          const parentValue = formChange?.[parentField]

          const requiredField =
            field.element !== 'textarea' && parentValue !== '' && parentValue

          const inputStyle = {
            cursor: 'text',
            minHeight:
              field.element === 'textarea' ? (isEditMode ? 100 : 0) : 'inherit',
            marginBottom: field.element === 'textarea' ? 10 : 'inherit',
          }

          return !isEditMode ? (
            <div
              key={field.source}
              style={{
                ...(styles.viewcontainer as CSSProperties),
                // @ts-ignore
                ...(isEditMode && styles.borderContainer),
                marginBottom: index === 0 ? 10 : 0,
              }}
            >
              <Text
                as={!printPDF ? 'p3' : 'h5'}
                style={{ marginTop: 5, color: colors.darkgrey }}
              >
                {label}
              </Text>
              {index === 0 ? (
                <InputText
                  className="ant-disabled-text-area"
                  value={field.value}
                  disabled
                  element={field.element}
                  placeholder=" "
                  style={inputStyle}
                  autoSize
                />
              ) : (
                <Text
                  as="p2"
                  style={{ color: colors.black, paddingBottom: 24 }}
                >
                  {field.value}
                </Text>
              )}
            </div>
          ) : (
            <InputText
              key={field.source}
              label={label}
              type={field.source}
              errorMessage={`${heading} ${label} is required!'`}
              required={requiredField}
              element={field.element}
              placeholder=" "
              style={inputStyle}
              autoSize
            />
          )
        })}
      </div>
    </div>
  )
}

export default MultiTextArea
